module.exports = __webpack_public_path__ + "static/media/CupMirror.0c4b2dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Achievements/CupMirror.png
// module id = 349
// module chunks = 0